<template>
  <div>
    <van-popup v-model="popShow" :close-on-click-overlay="false">
      <div class="pop-content">
        <div class="pop-content-img">
          <img src="../../../assets/images/activity/form-verification-icon2.png">
        </div>
        <div class="pop-content-title">
          <slot name="title"></slot>
        </div>
        <slot name="content"></slot>
        <slot name="button"></slot>
      </div>

      <div class="pop-close" @click="popShow = false">
        <img src="../../../assets/images/activity/form-verification-off.png">
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'LiveBroadcastPop',
  props: {

  },
  data () {
    return {
      popShow: false
    }
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.van-popup {
  width: 270px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0);
  .pop-content {
    background: url("../../../assets/images/activity/form-verification-header2.png") top no-repeat;
    background-size: 100% auto;
    padding: 30px 5px 10px 5px;
    text-align: center;
    border-radius: 10px;
    background-color: #fff;
    .pop-content-img {
      position: relative;
      width: 150px;
      padding-top: 20px;
      margin: 10px auto;
      img {
        width: 100%;
        height: 100%;
      }
      .pop-content-right {
        position: absolute;
        right: 0;
        bottom: 8px;
        width: 30px;
        height: 30px;
      }
    }
    .pop-content-title {
      line-height: 30px;
      font-size: 20px;
      font-weight: 600;
    }
    .pop-content-integral {
      padding-top: 20px;
      line-height: 30px;
      font-size: 14px;
      color: #999;
    }
    .pop-content-btn {
      padding-top: 20px;
      .button-line {
        height: 35px;
        line-height: 35px;
        margin: 0 50px;
        font-weight: 400;
        background-color: rgba(52, 122, 127, 1);
      }
    }
  }
  .pop-close {
    width: 39px;
    height: 39px;
    margin: 32px auto 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
